import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { OfflineBanner } from "@/components/OfflineBanner";
import { PromoBar } from "@/components/PromoBar";
import { ExitIntentPopup } from "@/components/ExitIntentPopup";
import { TrialGate } from "@/components/TrialGate";
import { InstallPrompt } from "@/components/InstallPrompt";
import { PresenceTracker } from "@/components/PresenceTracker";
import TVNavigation from "@/components/TVNavigation";
import { Navbar } from "@/components/Navbar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import LiveTV from "@/pages/LiveTV";
import Movies from "@/pages/Movies";
import Games from "@/pages/Games";
import Radio from "@/pages/Radio";
import Search from "@/pages/Search";
import MyList from "@/pages/MyList";
import Watch from "@/pages/Watch";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import Subscribe from "@/pages/Subscribe";
import PaymentCallback from "@/pages/PaymentCallback";
import Guide from "@/pages/Guide";
import Download from "@/pages/Download";
import ProfilePicker from "@/pages/ProfilePicker";
import AuthCallback from "@/pages/AuthCallback";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
          <SettingsProvider>
          <TVNavigation />
          <Navbar />
          <OfflineBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/live" element={<LiveTV />} />
            <Route path="/movies" element={<Movies />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/games" element={<Games />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/download" element={<Download />} />
            <Route path="/profiles" element={<ProtectedRoute><ProfilePicker /></ProtectedRoute>} />
            <Route path="/search" element={<Search />} />
            <Route path="/watch/:id" element={<Watch />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/join/:code" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/my-list" element={<ProtectedRoute><MyList /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
          <PromoBar />
          <ExitIntentPopup />
          <TrialGate />
          <InstallPrompt />
          <PresenceTracker />
          </SettingsProvider>
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
